"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gridQuery = exports.getAllGrids = void 0;
const types_1 = require("../../../types");
exports.getAllGrids = `
  query queryGrids($language: String!) {
    allGrids(language: $language) {
      id
      name
    }
  }
`;
exports.gridQuery = `
  query queryGridById($id: ID!, $language: String!) {
    grid(id: $id, language: $language) {
      id
      name
      meta {
        key
        value
      }
      rows {
        meta {
          key
          value
        }
        columns {
          layout {
            rowspan
            colspan
          }
          meta {
            key
            value
          }
          itemType
          itemId
          item {
            ... on Item {
              ...item
              ...product
            }
          }
        }
      }
    }
  }

  ${types_1.itemFullFragment}
  ${types_1.productFragment}
`;
//# sourceMappingURL=grid.js.map